import { Button, ButtonProps, Tooltip } from '@primer/react';
import React from 'react';

interface DisabledButtonWithTooltipProps extends ButtonProps {
  disabledReason?: string;
}

/* Primer's Tooltip component throws an error when there is not accessible child component.
This component works around that limitation by using aria-disabled='true' instead of the disabled
prop, and by explicitly setting the onClick handler to undefined for such cases.
    */
const ButtonWithTooltipWhenDisabled: React.FC<DisabledButtonWithTooltipProps> = ({
  disabled,
  disabledReason,
  children,
  ...props
}) => {
  // If not disabled, just return the standard Button
  if (!disabled || !disabledReason) {
    return <Button {...props}>{children}</Button>;
  }

  return (
    <Tooltip aria-label={disabledReason} direction="ne" text={disabledReason}>
      <Button {...props} aria-disabled="true" onClick={undefined}>
        {children}
      </Button>
    </Tooltip>
  );
};

export default ButtonWithTooltipWhenDisabled;
